import React from 'react';
import { motion } from 'framer-motion';

const Legal = () => {
    return (
        <div className="min-h-screen bg-cyber-gray text-white font-rajdhani relative overflow-hidden">
            {/* Background Grid Animation */}
            <div className="absolute inset-0 z-0 opacity-10 pointer-events-none">
                <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px]"></div>
            </div>

            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-20 relative z-10">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                >
                    <h1 className="text-4xl md:text-5xl font-bold font-orbitron text-neon-blue mb-12 border-b border-gray-800 pb-8">
                        OPERATIONAL PROTOCOLS
                    </h1>

                    <div className="space-y-12 text-gray-300 leading-relaxed font-mono text-sm">
                        <section>
                            <h2 className="text-xl font-bold text-white mb-4 uppercase tracking-widest flex items-center gap-2">
                                <span className="bg-neon-blue w-2 h-2 rounded-full"></span>
                                01. Terms of Engagement
                            </h2>
                            <p className="mb-4">
                                By accessing the VectorShift mainframe ("The Service"), you agree to be bound by these computational constraints. Unauthorized data injection or extraction attempts will trigger immediate termination of connection.
                            </p>
                            <p>
                                The Service is provided "AS IS" without warranty of any kind, explicit or implied holographic projections.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-white mb-4 uppercase tracking-widest flex items-center gap-2">
                                <span className="bg-neon-purple w-2 h-2 rounded-full"></span>
                                02. Data Privacy
                            </h2>
                            <p className="mb-4">
                                Your neural patterns and pipeline configurations are encrypted using military-grade quantum algorithms. We collect telemetry data solely to optimize system throughput.
                            </p>
                            <p>
                                VectorShift does not sell, trade, or transfer your conscious data to third-party entities unless required by Intergalactic Law.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-white mb-4 uppercase tracking-widest flex items-center gap-2">
                                <span className="bg-green-400 w-2 h-2 rounded-full"></span>
                                03. Liability
                            </h2>
                            <p>
                                In no event shall VectorShift be liable for any data singularity events, temporal paradoxes, or loss of productivity resulting from the use of our automated pipelines.
                            </p>
                        </section>
                        <section>
                            <h2 className="text-xl font-bold text-white mb-4 uppercase tracking-widest flex items-center gap-2">
                                <span className="bg-red-500 w-2 h-2 rounded-full"></span>
                                04. Termination
                            </h2>
                            <p>
                                We reserve the right to sever your connection to the mainframe at any time for violation of these protocols.
                            </p>
                        </section>
                    </div>

                    <div className="mt-16 pt-8 border-t border-gray-800 text-center text-gray-500 text-xs text-mono">
                        LAST PROTOCOL UPDATE: 2024.10.15 // CHECKSUM: A1B3-F9
                    </div>
                </motion.div>
            </div>
        </div>
    );
};

export default Legal;
